import { Link } from 'react-router-dom'
import { dismiss, useToasts } from '../lib/toasts'

/** The corner where a reply that landed, an answer waiting, or a send that failed says so for a few seconds. */
export function Toasts() {
  const list = useToasts()
  if (list.length === 0) return null
  return (
    <div className="toasts" aria-live="polite">
      {list.map((t) => (
        <div key={t.id} className={`toast ${t.kind}`} role="status">
          <div className="toast-body">
            <strong>{t.title}</strong>
            {t.body && <span className="small">{t.body}</span>}
            {t.href && <Link className="small" to={t.href} onClick={() => dismiss(t.id)}>Open it</Link>}
          </div>
          <button type="button" className="toast-close" onClick={() => dismiss(t.id)} aria-label="Dismiss">×</button>
        </div>
      ))}
    </div>
  )
}
